import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ChapterDelete = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [chapter, setChapter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchChapter = async () => {
      try {
        const response = await axios.get(`/api/chapters/${id}`);
        setChapter(response.data);
      } catch (err) {
        setError("Error loading chapter");
        console.error("Error fetching chapter:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchChapter();
  }, [id, navigate]);

  const handleDelete = async () => {
    try {
      await axios.delete(`/api/chapters/${id}`);
      setSuccess(true);
      setTimeout(() => {
        navigate("/chapter/list");
      }, 2000);
    } catch (err) {
      setError("Error deleting chapter");
      console.error("Error deleting chapter:", err);
    }
  };

  if (loading) return <div className="container mx-auto p-4">Loading...</div>;
  if (error)
    return <div className="container mx-auto p-4 text-red-500">{error}</div>;
  if (!chapter)
    return <div className="container mx-auto p-4">Chapter not found</div>;

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Delete Chapter</h1>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="mb-4">
          Are you sure you want to delete the chapter "{chapter.title}"? This
          action cannot be undone.
        </p>
        <div className="flex space-x-4">
          <button
            onClick={handleDelete}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Yes, Delete Chapter
          </button>
          <button
            onClick={() => navigate("/chapter/list")}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
        {success && (
          <p className="mt-4 text-green-500">
            Chapter deleted successfully. Redirecting...
          </p>
        )}
      </div>
    </div>
  );
};

export default ChapterDelete;
